import AdminClassDesignerController from '~/pages/admin/class-designer/admin-class-designer.controller';

export default class ClassDesignerHomeController {
	/* @ngInject */
	/**
	 * @param {import('angular').ILocationService} $location
	 */
	constructor($location) {
		this.$location = $location;

		/** @type {?AdminClassDesignerController} */
		this.ctrl = null;

		this.schemaTmp = [];
	}

	searchNodeKid() {
		this.$location.search({
			create:    true,
			edit:      true,
			kid:       `K_NODE;${this.ctrl?.User.getRef()}`,
			openNode:  this.ctrl?.searchKid,
			duplicate: null,
		});
		// this.active = this.tabs.length - 1;
	}
}
